import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const messages = ['🚀 ¡Acaba de suceder! Javier de México acaba de descargar su guía IA al Rescate.', '👀 Tendencia actual: 18 personas están personalizando sus prompts en este momento.', '⚡ ¡Acceso instantáneo! Elena de Colombia compró el eBook hace 45 segundos.', "⭐ Review 5/5: 'Mis correos ahora se escriben solos. Increíble.' — Marcos P.", '⚠️ ¡Casi agotado! Solo quedan 7 licencias con el descuento del 60%.', '🌎 Desde Argentina: Sofía acaba de optimizar su agenda semanal con IA.', '✅ Verificado: Todos los prompts de esta guía han sido probados en GPT-4o.', '🔥 ¡Nueva descarga! Ricardo de España acaba de ahorrar 3 horas de su lunes.'];
export function PopupNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial show after 3 seconds
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
      // Hide after 6 seconds
      setTimeout(() => {
        setIsVisible(false);
        setCurrentIndex(prev => (prev + 1) % messages.length);
      }, 6000);
    }, 3000);
    // Then cycle every 24 seconds
    const intervalTimer = setInterval(() => {
      setIsVisible(true);
      // Hide after 6 seconds
      setTimeout(() => {
        setIsVisible(false);
        setCurrentIndex(prev => (prev + 1) % messages.length);
      }, 6000);
    }, 24000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <div className="fixed bottom-5 left-5 z-[9999] pointer-events-none" data-id="element-148">
      <AnimatePresence data-id="element-149">
        {isVisible && <motion.div initial={{
        opacity: 0,
        x: -100,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -50,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-white/95 backdrop-blur-md border border-cyan-neon rounded-xl p-4 shadow-[0_8px_32px_rgba(0,242,255,0.2)] max-w-[320px] pointer-events-auto" data-id="element-150">
            <p className="text-slate-800 text-sm font-medium leading-snug" data-id="element-151">
              {messages[currentIndex]}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}